import { isIE, isMacOs, isSafari } from "react-device-detect"

export const getResolution = (data: string) => {
    if ((isMacOs && isSafari) || isIE)
        return data + ' m-b-150'
    else if(isMacOs && !isSafari )
        return data + ' m-b-80'
    else
        return data
}